import { Navigate, useLocation } from 'react-router-dom'
import noop from 'lodash/noop'

import useBillingInfo from '../services/useBillingInfo'
import { Subscription } from '../types'
import { Plans } from './Plans'

export default () => {
  const { subscription } = useBillingInfo()

  return <DefaultRouter subscription={subscription} />
}

export function DefaultRouter(props: {
  subscription: Subscription | null | undefined
}): React.ReactElement {
  const location = useLocation()

  // Renders loading placeholders while the subscription is being loaded
  if (props.subscription === undefined) {
    return (
      <Plans
        plans={undefined}
        organization={undefined}
        subscription={undefined}
        goToSummaryPage={noop}
        goToCheckoutPage={noop}
      />
    )
  }

  if (props.subscription) {
    return (
      <Navigate
        replace
        to={{
          pathname: '/summary',
          search: location.search,
        }}
      />
    )
  }

  return (
    <Navigate
      replace
      to={{
        pathname: '/plans',
        search: location.search,
      }}
    />
  )
}
